import { Injectable } from "@angular/core";

export interface Config {
    PESSOA_ID: number;
    SEGURADO_ID: number,
    USR_LOGIN_ID: number,   
    SITUACAO_FUNCIONAL_ID: number,   
    URL: string;
    TOKEN: string;
    CARGO: string;
    CATEGORIA: string;
    CATEGORIA_ID: number;
    DATA_ULTIMO_ACESSO: string;
    EMAIL1: string;
    FONE_RESIDENCIAL: string;
    LOGIN: string;
    MAT_ORG: string;
    NOME: string;
    NUMERO_VISITAS: string;
    ORGAO: string;
    SEXO: string;
    CARGO_DESC: string;
    DATA_NASC: string;
}

@Injectable()
export class UtilDadosLogado {
    DadosAcesso(): Config {
        return JSON.parse(localStorage.getItem('AcessoAdm'));
    }
}


// WEBPACK FOOTER //
// ./src/app/servicos/util.logado.ts